<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>内容管理</a-breadcrumb-item>
    <a-breadcrumb-item>端原片库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 视频号 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nameModel" class="tool-item" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="1" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="12">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap; text-align: right;">
            <!-- 上传按钮 -->
            <Upload
              accept=".xlsx,.xls,.csv"
              uploadSource="DyFilmLibrary"
              :beforeUploadPro="beforeUploadBatchPro"
              style="display: inline-block;"
            >
              <template #up-title>批量上传</template>
            </Upload>
            <!-- 添加短剧 -->
            <!-- <a-button @click="touchAdd" type="primary"><plus-outlined /> 新建短剧</a-button> -->
            <!-- 账号管理 -->
            <a-button @click="touchAccount" style="margin-left: 16px">账号管理</a-button>
            <!-- cookie设置 -->
            <a-button @click="touchCookie" style="margin-left: 16px">cookie设置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 片源 -->
      <template v-if="column.key === 'film_type'">
        {{ (FilmTypesDy.find(item => item.value === record.film_type) || {}).text || '-' }}
      </template>
      <!-- 媒体 -->
      <template v-else-if="column.key === 'account_type'">
        {{ (AccountChannelTypes.find(item => item.value === record.account?.type) || {}).text || '-' }}
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
      </template>
      <template v-else>{{ record[column.key] || '-' }}</template>
    </template>
  </a-table>
  <!-- 新增 -->
  <Add ref="RefAdd" @success="onAddSuccess"></Add>
  <!-- 账号管理 -->
  <AccountManager ref="RefAccountManager" @success="getSelectList"></AccountManager>
  <!-- cookie设置列表 -->
  <CookieList ref="RefCookieList"></CookieList>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import * as Ex from "@netjoy/excelex"
import Pub from '@/utils/public'
import Upload from '@/components/Upload'
import Add from './components-dy-film-library/Add.vue'
import CookieList from './components-dy-film-library/CookieList.vue'
import AccountManager from './components-dy-film-library/AccountManager.vue'
import { FilmTypesDy, AccountTypes, AccountChannelTypes } from '@/utils/constant'
import { playletList, dyBatchImport } from '@/api/copyright'
import ex2json from "ex2json";

// 加载
let isLoading = ref(false)
// 新增结算
let RefAdd = ref(undefined)
// 服务商管理
let RefAccountManager = ref(undefined)
// cookie设置列表
let RefCookieList = ref(undefined)
// 剧名
let name = ref(undefined) 
let nameModel = ref(undefined)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '剧名',
    dataIndex: 'playlet_name ',
    key: 'playlet_name'
  },
  {
    title: '抖音剧ID',
    dataIndex: 'playlet_id',
    key: 'playlet_id'
  },
  {
    title: '关联剧名',
    dataIndex: 'drama_name',
    key: 'drama_name'
  },
  {
    title: '总集数',
    dataIndex: 'seq_count',
    key: 'seq_count'
  },
  {
    title: '片源',
    dataIndex: 'film_type',
    key: 'film_type'
  },
  {
    title: '账号',
    dataIndex: 'account_id',
    key: 'account_id'
  },
  {
    title: '媒体',
    dataIndex: 'account_type',
    key: 'account_type'
  },
  {
    title: '上架日期',
    dataIndex: 'publish_date',
    key: 'publish_date'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount (() => {
  // 初始化选择项列表
  getSelectList()
  // 获取推广数据列表
  getList()
})

// 添加短剧
function touchAdd () {
  RefAdd.value.showDrawer({})
}

// 编辑短剧
function touchEdit (record) {
  RefAdd.value.showDrawer(record)
}

// 账号管理
function touchAccount () {
  RefAccountManager.value.showDrawer()
}

// cookie设置
function touchCookie () {
  RefCookieList.value.showDrawer()
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 查询
function touchSearch () {
  // 调整参数
  name.value = nameModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  name.value = undefined
  nameModel.value = undefined
  // 初始化获取
  touchSearch()
}

function onAddSuccess () {
  // 更新检索列表
  getSelectList()
  // 搜搜
  touchSearch()
}

// 获取推广数据列表
function getList () {
  isLoading.value = true
  const params = {
    name: name.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  playletList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 批量上传
function beforeUploadBatchPro (file, fileList) {
  // 转成成 json
  ex2json.parse(file, (code, res) => {
    // 上传服务器
    const list = res[0].list || []
    list.shift();
    const newList = list.filter(item => {
      return !(Array.isArray(item) && item.length === 0)
    })
    dyBatchImport({'data': newList}).then(res => {
      if (res.code === 0) {
        message.success('上传成功')
        // 刷新列表
        getList()
      } else {
        message.error(res.message)
      }
    }).catch(err => {
      message.error(err.message)
    })
  });
  // 返回 false 不进行上传
  return false
}

// 初始化选择项列表
function getSelectList () {
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 30px;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>